import React from 'react'
import { translate } from 'react-i18next'
import './index.sass'

const AudioInfo = ({ author, language, t }) =>
  author && language ? (
    <div className='audio-info'>
      <span>{`${t('general.voice')} ${author.replace(/Voice/, '')}`}</span>
      <span>{t(`Language.${language}`)}</span>
    </div>
  ) : null

export default translate('translations')(AudioInfo)
